module.exports = __webpack_public_path__ + "img/requirement-order@2x.b317d691.png";